import { Component, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'app/services/app/app.service';
import { RestService } from '../../services/rest/rest.service';
import { Constants } from 'app/components/utils/Constants';
import { Log } from 'app/core/logging/log';

@Component({
  selector: 'app-my-reserves',
  templateUrl: './my-reserves.component.html',
  styleUrls: ['./my-reserves.component.scss']
})
export class MyReservesComponent implements OnInit {

  reserves: any[] = [];

  constructor(
    private appService: AppService, 
    private restService: RestService, 
    private element : ElementRef) { 

  }

  ngOnInit() {
    this.getMyReserves();
  }

  getMyReserves(){
    this.restService.getMyReserves().subscribe(result => {
      this.reserves = result.content;

    });
  }

  downloadTicket(invoiceNumber:any){
    this.restService.getInvoiceBase64User(invoiceNumber).subscribe(result => {
      let pdfWindow = window.open("")
      pdfWindow.document.write(
          "<head><title>Invoice "+invoiceNumber+"</title></head>" +
          "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
          encodeURI(result.file) + "'></iframe>"
      )

    });
  }

  changePasswordOrder(uuid:string){
    const passC:any = window.document.getElementById('passC-'+uuid);
    const passP:any = window.document.getElementById('passP-'+uuid);

    let pass = { checkoutPassword: passC != null ? passC.value : '', provisionalPassword: passP != null ? passP.value : '', typePassword: "USER" }
    this.restService.changePasswordOrder(uuid, pass).subscribe(
      result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      }, 
      error => {
          this.getMyReserves();
      }
    );
  }

  validatePassElement(i){
    const passC:any = window.document.getElementById('passC-'+i);
    const validationPassC:any = window.document.getElementById('validationPassC-'+i);
    const passP:any = window.document.getElementById('passP-'+i);
    const validationPassP:any = window.document.getElementById('validationPassP-'+i);
    const btSubmit:any = window.document.getElementById('btChangeCode-'+i);
    Log.debug(passC, passP)
    Log.debug('validatePassElement', { passC: passC, passP: passP });
    //Recogida
    if(passC != null){
      if(!this.validatePin(passC.value)){
        Log.error('validatePassElement', { passC: 'nok' });
        validationPassC.children[0].textContent = this.appService.getTraduccion('reserves.pinValidation');
        passC.style.borderColor = "red";
        validationPassC.style.cssText = "display:block !important";
        btSubmit['disabled'] = true;
      }else if(passC != null && passP != null && (passC.value == passP.value)){
        Log.error('validatePassElement', { passC: 'same' });
        validationPassC.children[0].textContent = this.appService.getTraduccion('reserves.pinSame');
        passC.style.borderColor = "red";
        validationPassC.style.cssText = "display:block !important";
        btSubmit['disabled'] = true;
      }else{
        Log.debug('validatePassElement', { passC: 'ok' });
        passC.style.borderColor = "#DDDDDD";
        validationPassC.style.cssText = "display:none !important";
        btSubmit['disabled'] = false;
      }
    }
    
    //Entrega
    if(passP != null){
      if(!this.validatePin(passP.value)){
        Log.error('validatePassElement', { passP: 'nok' });
        validationPassP.children[0].textContent = this.appService.getTraduccion('reserves.pinValidation');
        passP.style.borderColor = "red";
        validationPassP.style.cssText = "display:block !important";
        btSubmit['disabled'] = true;
      }else if(passC != null && passP != null && (passC.value == passP.value)){
        Log.error('validatePassElement', { passP: 'same' });
        validationPassP.children[0].textContent = this.appService.getTraduccion('reserves.pinSame');
        passP.style.borderColor = "red";
        validationPassP.style.cssText = "display:block !important";
        btSubmit['disabled'] = true;
      }else{
        Log.debug('validatePassElement', { passP: 'ok' });
        passP.style.borderColor = "#DDDDDD";
        validationPassP.style.cssText = "display:none !important";
        btSubmit['disabled'] = false;
      }
    }

  }

  validatePin(pin:any) {    
    return pin != null && pin != '' && /[0-9]/.test(pin) && pin.length == 4;
  }

  formatPin(reserve: any, value: any){
    let start:string = '';
    let id:string = String(reserve.lockerId);
    if(reserve.lockerPassword.typePassword == 'USER'){
      start = '0';
      id = String(this.appService.usuario.id);
    }
    
    let filled = value.padEnd(4, '*');
    return start +''+ id +''+ filled;
  }

  getLastLine(reserve:any){
    try{
      return reserve.payments[reserve.payments.length-1].orderUuid;
    }catch(e){
      Log.error('getLastLine', { msg: 'Line not found' });
    }
    return '';
  }

}
